/** Shared season ids (Aug–Jul football year). */

export const CURRENT_SEASON = "2026-27";

export const SEASON_OPTIONS = [
  { id: "2026-27", label: "2026–27" },
  { id: "2025-26", label: "2025–26" },
];

/** Hide the “open leagues” banner from this date (local midnight, 1 Sept). */
export const TABLE_PREDICTIONS_OPEN_BANNER_END = new Date(2026, 8, 1);

export function shouldShowTablePredictionsOpenBanner(now = Date.now()) {
  return now < TABLE_PREDICTIONS_OPEN_BANNER_END.getTime();
}

export function formatSeasonLabel(seasonId) {
  const found = SEASON_OPTIONS.find((s) => s.id === seasonId);
  if (found) return found.label;
  if (!seasonId) return "";
  return String(seasonId).replace("-", "–");
}

/** Compact label for card titles, e.g. "2026-27" → "26/27". */
export function formatSeasonShortLabel(seasonId) {
  if (!seasonId) return "";
  const parts = String(seasonId).split("-");
  if (parts.length === 2) {
    const start = parts[0].slice(-2);
    const end = parts[1];
    return `${start}/${end}`;
  }
  return String(seasonId).replace("-", "/");
}
